<template>
  <v-card
    outlined
    rounded="sm"
    class="mx-4 my-2"
    :class="{
      'bg-custom-light-blue' : cycle.status == 'finished'
    }"
  >
    <v-card-text class="py-0">
      <v-container fluid>
        <v-row>
          <v-col
            class="d-flex flex-column "
            :class="{
              'pb-0' : $vuetify.breakpoint.smAndDown
            }"
            :sm="12"
            :md="5"
            :lg="5"
            :xs="12"
          >
            <div
              class="ml-sm-1 w-100"
              :class="{ 'd-flex' : $vuetify.breakpoint.smAndDown }"
              style="min-width: 300px"
            >
              <p class="m-0 font-weight-bold text-theme mr-2">
                {{ cycle.cycle_name }} 
              </p>
              <p class="m-0">
                {{ cycle.begin_formatted }} 
                <span
                  class="font-weight-normal"
                > até </span>
                {{ cycle.end_formatted }}
              </p>
            </div>
          </v-col>
          <v-col 
            class="d-flex justify-content-md-end py-0"
            :md="6"
            :sm="8" 
            :xs="12"
          >
            <div
              v-if="cycle.should_select_modules && cycle.plan == 'full'"
              class="d-flex align-items-center justify-content-md-end cycle-modules"
              :class="{
                'justify-content-center my-2' : $vuetify.breakpoint.smAndDown
              }"
            >
              <v-btn
                v-if="cycle.plan == 'full'"
                outlined
                :small="!$vuetify.breakpoint.smAndDown"
                color="nitro"
                :to="{ name: selectModulesRouteName }"
              >
                <span class="first-letter-capitalize">
                  Selecionar módulos
                </span>
              </v-btn>
            </div>
            <div
              v-else-if="cycle.count_modules == 0 || !cycle.started"
              class="d-flex align-items-center justify-content-md-center"
            >
              <ModuleInfoPlaceholder
                v-for="m in cycle.expected_modules_qty"
                :key="m"
                :cycle="cycle"
                :module-order="m"
                class="mx-1"
              />
              <ChallengeInfo
                :cycle="cycle"
                class="mx-1"
              />
            </div>
            <div
              v-else
              class="d-flex align-items-center justify-content-md-end "
            >
              <div
                v-for="m in cycle.modules"
                :key="m.id"
                class="d-flex"
              >
                <ModuleInfo
                  :cycle="cycle"
                  :module="m"
                  class="mx-1"
                />
              </div>
              <ModuleInfoPlaceholder
                v-for="m of count_left_modules"
                v-if="count_left_modules > 0"
                :key="m"
                :cycle="cycle"
                :module-order="m + cycle.modules.length"
                class="mx-1"
              />
              <ChallengeInfo
                :cycle="cycle"
                class="mx-1"
              />
            </div>
          </v-col>
          <v-col
            v-if="!cycle.should_select_modules"
            :md="1"
            :sm="4"
            :xs="12"
            class="d-flex align-items-center justify-content-end"
          >
            <RedirectButton 
              
              :cycle="cycle"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-progress-linear 
      :value="cycle.status == 'not_started' ? 0 : cycle.status == 'is_started' ? 50: 100"
      background-color="#d9d9d9"
      :color="'#060181'"
    />
  </v-card>
</template>
<script>

import ChallengeInfo from './ChallengeInfo.vue'
import RedirectButton from './RedirectButton.vue'
import { selectModulesRouteName } from "@/student/constants/routes"
import { mapGetters } from 'vuex'
import ModuleInfo from './ModuleInfo.vue';
import ModuleInfoPlaceholder from './ModuleInfoPlaceholder.vue';

export default {
    components: { ModuleInfo, ModuleInfoPlaceholder, RedirectButton, ChallengeInfo },
    props: {
        cycle: {
            type: Object,
            required: true,
        }
    },
    data(){
      return {
        selectModulesRouteName,
      }
    },
    computed: {
      ...mapGetters(['view_plan']),
       count_left_modules(){
        let left = this.cycle.expected_modules_qty - this.cycle.modules.length
       return  left < 0 ? 0 : left
      }  
    },
    
}
</script>
